const defaultState = {}

export default function logins(state = defaultState) {
  return state
}
